import {
  ChevronDownOutlineIcon,
  ChevronLeftOutlineIcon,
  ChevronRightOutlineIcon,
} from '@applyboard/ui-icons';
import { Calendar } from 'dayzed';
import { InternalButton, InternalButtonProps } from '../../InternalButton';
import { useFullTheme } from '~/design';
import { useLang } from '~/internal/LanguageContext';
import { useId } from '~/utils';
import { Ref } from 'react';

const getMonthNamesLong = (lang: 'en-US' | 'fr-CA' | undefined) => {
  const monthNamesLong =
    lang === 'fr-CA'
      ? [
          'Janvier',
          'Février',
          'Mars',
          'Avril',
          'Mai',
          'Juin',
          'Juillet',
          'Août',
          'Septembre',
          'Octobre',
          'Novembre',
          'Décembre',
        ]
      : [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ];

  return monthNamesLong.map((month, idx) => ({ label: month, value: idx }));
};

interface DatePickerToolbarProps {
  backBtn: Pick<InternalButtonProps, 'aria-label' | 'disabled' | 'onClick'>;
  forwardBtn: Pick<InternalButtonProps, 'aria-label' | 'disabled' | 'onClick'>;
  hideYearPicker?: boolean;
  calendar: Calendar;
  onClick: () => void;
  yearPickerBtnRef?: Ref<HTMLButtonElement>;
}

export function DatePickerToolbar({
  backBtn,
  calendar,
  hideYearPicker,
  forwardBtn,
  onClick,
  yearPickerBtnRef,
}: DatePickerToolbarProps) {
  const theme = useFullTheme();
  const lang = useLang();
  const descId = useId();
  return (
    <div css={{ display: 'flex', justifyContent: hideYearPicker ? 'end' : 'space-between' }}>
      {!hideYearPicker && (
        <InternalButton
          aria-describedby={descId}
          aria-live="assertive"
          emphasis="transparent"
          onClick={onClick}
          ref={yearPickerBtnRef}
          size="sm"
          trailIcon={ChevronDownOutlineIcon}
        >
          {`${getMonthNamesLong(lang)[calendar.month].label} ${calendar.year}`}
        </InternalButton>
      )}

      <div css={{ display: 'none' }} id={descId}>
        Click to pick the year
      </div>

      <div css={{ display: 'flex', gap: theme.spacing[1] }}>
        <InternalButton
          emphasis="transparent"
          leadIcon={ChevronLeftOutlineIcon}
          size="sm"
          {...backBtn}
        />
        <InternalButton
          emphasis="transparent"
          leadIcon={ChevronRightOutlineIcon}
          size="sm"
          {...forwardBtn}
        />
      </div>
    </div>
  );
}
